// extracted by mini-css-extract-plugin
export var center = "_1a-2";
export var clickableRow = "_1a-5";
export var expandedRow = "_1a-7";
export var hoverable = "_1a-4";
export var left = "_1a-1";
export var right = "_1a-3";
export var row = "_1a-0";
export var selectedRow = "_1a-6";
export var summaryRow = "_1a-8";